export default __webpack_public_path__ + "static/media/04-profile-min.6fe4a2b3.png";